import React, { Component } from 'react';
import "./mobileHeader.css";
import { Link } from "react-router-dom";
import {CopyrightText} from "./../../utils/constants";

export default class MobileHeader extends Component {
  constructor(props) {
      super(props);
      this.state={};
  }

  componentDidUpdate = ()=>{
    if(this.props.active && !this.state.active){
      this.fireItUp();
    }
    if(!this.props.active && this.state.transitionReady){
      this.setState({
        menuTransitionReady:false,
        transitionReady:false
      },()=>{
        setTimeout(()=>{
          this.setState({
            active:false
          })
        },500);
      })
    }
  }
  fireItUp = () =>{
    this.setState({
      active:true,
    },()=>{
      setTimeout(()=>{
        this.setState({
          transitionReady:true
        })
        setTimeout(()=>{
          this.setState({
            menuTransitionReady:true
          })
        },50);
      },50);
    })
  }
  render() {
    let activeClass = "";
    let transitionClass ="transition-not-ready";
    let menuTransitionClass ="";
    if (this.state.active){
      activeClass = "active"
    }
    if(this.state.transitionReady){
      transitionClass = "ready"
    }
    if(this.state.menuTransitionReady){
      menuTransitionClass = "transition-ready"
    }
    let menuOptions = [
      <Link to="/" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'Home'}</h4></Link>,
      <Link to="/subscribe" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'Subscribe'}</h4></Link>,
      <Link to="/about" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'About'}</h4></Link>,
      <Link to="/books" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'Books'}</h4></Link>,
      <Link to="/speakingOps" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'Speaking'}</h4></Link>,
      <Link to="/observations" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'Articles'}</h4></Link>,
      <Link to="/contact" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'Contact'}</h4></Link>,
      <Link to="/fiveBrainFucks" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'5 Brain F*cks PDF'}</h4></Link>,
      <Link to="/sevenDayChallenge" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'7 Days to Joy'}</h4></Link>,
      //<Link to="/press" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'Press'}</h4></Link>,
      //<NavLink to="/inspiration" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'Daily Inspiration'}</h4></NavLink>,
      //<Link to="/yearlyAudit" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'Audit of the Year PDF'}</h4></Link>,
      //<Link to="/findingTime" onClick={this.props.toggleMobileMenu}><h4 className="header-link">{'Finding the Time PDF'}</h4></Link>
    ]
    return (
      <div className={"mobile-header-container "+activeClass}>
        <div className={"mobile-header "+transitionClass}>
          <div className="mobile-header-container-close" onClick={this.props.toggleMobileMenu}>
            <img className="full-width" src="/images/close-white.png" />
          </div>
          <div className={menuTransitionClass} style={{marginTop:"60px"}}>
            {menuOptions.map((data,index) =>{
              let delay = (index)*.15+"s";
              return(
                <div className="menu-transition" style={{animationDuration:delay}}>{data}</div>
              )
            })}
          </div>
          <div className="menu-sticky">
            <img style={{width:"80%", margin:"auto", marginBottom:"10px"}} src="/images/km-logo-wide-white.png" />
          <div className="menu-copyright">{CopyrightText}</div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/header/mobileHeader.js